import Footer from '@components/shared/Footer/Footer';
import YourInfoForm from '@components/YourInfoForm/YourInfoForm';
import { useTexts } from 'utils/useTexts';

const YourInfo = () => {
  const { t } = useTexts();
  return (
    <>
      <YourInfoForm />

      <Footer text={t('yourInformation.footer')} />
    </>
  );
};

export default YourInfo;
